import HeadboardSimpleProps from "./headboard-simple.types";

const validateDescription = (raw) => {
  try {
    return JSON.parse(raw)?.content[0]?.content[0]?.value;
  } catch (error) {
    return "";
  }
};

const headboardSimpleAdapter = (data: any): HeadboardSimpleProps => ({
  title: data.tituloPrincipal || "",
  bgImage: data.imagenHeader?.file?.url || "",
  breadcrumb: data.migaDePan || "",
  description: validateDescription(data?.descripcion?.raw),
  btnText: data.tituloBoton || "",
  btnLink: data.redireccionBoton || "",
  isHome: false,
});

const headboardSimpleHomeAdapter = (data: any): HeadboardSimpleProps => ({
  title: data.tituloGeneral || "",
  bgImage: data.imagenPrincipal?.file?.url || "",
  breadcrumb: "",
  description:
    JSON.parse(data.descripcion?.raw)?.content[0]?.content[0]?.value || "",
  btnText: data.tituloBoton || "",
  btnLink: data.redireccionBoton || "",
  darkMode: false,
  isHome: true,
});

export default headboardSimpleAdapter;
export { headboardSimpleHomeAdapter };
